import type { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs';
import { useFindFleetDetails } from '@services/queries/fleet/find-fleet-details.query';

export const FleetDetailsBreadcrumbValue = ({ match }: BreadcrumbComponentProps<'fleetId'>) => {
  const { data } = useFindFleetDetails(match.params.fleetId as string);

  return <>{data ? data.name : '-'}</>;
};
